import {
  Box,
  Button,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Link,
  NavLink,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import {
  changedAgencyIdFunc,
  closeTimeModal,
  openTimeModal,
  resetAllBodyParts,
  resetUserFeedNotifications,
  setEndTime,
  setGoBackFunc,
  setIsRunning,
  setIsStopped,
  setNavigateItemFunc,
  setPausedTime,
  setPauseStartTime,
} from "../../actions/AppConfig";
import {
  resetAllPatients,
  resetPatientDetailByPatientId,
  resetClientPainlogs,
  resetPatientListingStates,
} from "../../actions/Patients";
import styled from "@emotion/styled";
import { useSelector } from "react-redux";
import AlertDialog from "../AlertDialog";
import EndTimeModalContent from "../EndTimeModalContent";
import dayjs from "dayjs";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import PractiseBoxCard from "../PractiseBoxCard";
import {
  AddPractiseIconBlack,
  BillingReceiptIcon,
  HelpIcon,
  TickCircleIcon,
} from "../../assets/constants";
import {
  createWorkspaceFunc,
  getAllAgenciesListFunc,
  inviteAgentFunc,
  resetAgentInvite,
  resetCreateWorkSpace,
} from "../../actions/Agency";
import RectangleSkeletons from "../RectangleSkeletons";
import AddPractiseContent from "../AddPractiseContent";
import { validateEmail } from "../../utils/helpers";
import AlertMessage from "../../common/AlertMessage";
import BillingPageIcon from "../../icons/BillingPageIcon";
import BillingModalContent from "../BillingModalContent";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import OrganizationIcon from "../../icons/OrganizationIcon";
import { getOrganizationFunc } from "../../actions/OrganizationActions";
import {
  resetAssignBulk,
  resetImportStatus,
} from "../../actions/ImportFileActions";
import { resetStepCounts } from "../../actions/StepsCountActions";
import UserProfileBox from "../UserProfileBox";
import { segmentTrack } from "../../utils/helpers/tracking_utils";
import dashboardLists from "../../utils/dashboardLists";

const StyledListItem = styled(ListItem)(({ theme }) => ({
  "&.activeTab": {
    background: "rgba(0, 0, 0, 0.10)",
    "&:hover": {
      "& svg path": {
        stroke: "#fff !important",
      },
    },
    "&& .Mui-selected, && .Mui-selected:hover": {
      backgroundColor: "#0C80F3 !important",
      borderRadius: "8px !important",
      "&, & .MuiListItemIcon-root": {
        color: "#fff !important",
      },
    },
  },
}));

const StyledListItemIcon = styled(ListItemIcon)(() => ({
  minWidth: "26px !important",
}));

const StyledListItemText = styled(ListItemText)(() => ({
  "& span": {
    fontSize: "1.5rem !important",
  },
  "&.activeColor": {
    color: "#fff !important",
  },
}));

const Sidedrawer = ({ drawerWidth, selectedPath, setSelectedPath }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const organizationId = Cookies.get("org_id_vita");

  // const classes = Styles();
  const pathName = location?.pathname;
  const { id } = useParams();
  // const [selectedList, setSelectedList] = useState(
  //   parseInt(localStorage.getItem("selectedIndex")) || 0
  // );
  const dispatch = useDispatch();
  const [goBackTimer, setGoBackTimer] = useState(false);
  const [allPractices, setAllPractices] = useState([]);
  const [openMorePractiseModal, setOpenMorePractiseModal] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [practiseName, setPractiseName] = useState("");
  const [ownerName, setOwnerName] = useState("");
  // const [selectedPath, setSelectedPath] = useState(pathName);
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [OpenInviteMessage, setOpenInviteMessage] = useState(false);
  const [successInviteMessage, setSuccessInviteMessage] = useState(null);
  const [openBillingModal, setOpenBillingModal] = useState(false);

  const [openModal, setOpenModal] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenModal(false);
  };

  const timerModal = useSelector((state) => state.timerModal);
  const { isRunning, isPaused, isStopped } = timerModal;

  const getAllAgencies = useSelector((state) => state.getAllAgencies);
  const {
    loading: loadingAllAgencies,
    error: errorAllAgencies,
    allAgencies,
  } = getAllAgencies;

  const getOrganization = useSelector((state) => state.getOrganization);
  const {
    loading: loadingOrg,
    error: errorOrg,
    organizationDetail,
  } = getOrganization;

  const agentProfile = useSelector((state) => state.agentProfile);
  const {
    loading: loadingAgentProfile,
    error: errorAgentProfile,
    agentUser,
  } = agentProfile;

  const getAgencyDetail = useSelector((state) => state.getAgencyDetail);
  const { agencyDetail } = getAgencyDetail;

  const createWorkspace = useSelector((state) => state.createWorkspace);
  const {
    loading: loadingAgency,
    error: errorAgency,
    workspace,
  } = createWorkspace;

  const inviteAgent = useSelector((state) => state.inviteAgent);
  const {
    loading: loadingAgent,
    error: errorAgent,
    invitedAgent,
  } = inviteAgent;

  const currentAgencyId = Cookies.get("agency_id_vita");

  // useEffect(() => {
  //   const storedIndex = parseInt(Cookies.get("selectedIndex"));
  //   if (storedIndex !== selectedList) {
  //     setSelectedList(storedIndex || 0);
  //   }
  // }, []);

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const helpLinkHandler = () => {
    // Intentionally do not redirect/navigate on Help.
    // (Previously opened an external Microsoft Form.)
    if (agentUser?.agent && agencyDetail?.agency) {
      segmentTrack({
        event: "help",
        agent: agentUser?.agent,
        agency: agencyDetail?.agency,
      });
    }
  };

  const switchWorkspaceHandler = (event) => {
    if (!isRunning && !isPaused && isStopped && pathName === `/patient/${id}`) {
      navigate("/patients");
    } else if (!isRunning && !isPaused) {
      setAnchorEl(event.currentTarget);
    } else {
      openStopTimeModalHandler();
      dispatch(setGoBackFunc(true));
    }
  };
  const closeWorkSpaceHandler = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    setSelectedPath(pathName);
    let pageTitle = "BiosyncIQ";
    if (pathName === "/") {
      pageTitle = "BiosyncIQ | Dashboard";
    } else if (pathName === "/patients" || pathName === "/import-patients") {
      pageTitle = "BiosyncIQ | Patients";
    } else if (pathName === "/reports") {
      pageTitle = "BiosyncIQ | Reports";
    } else if (pathName === "/billing-report") {
      pageTitle = "BiosyncIQ | Billing Report";
    }
    // else if (pathName === "/clients") {
    //   pageTitle = "BiosyncIQ | Clients";
    // } else if (pathName === "/marketing") {
    //   pageTitle = "BiosyncIQ | Marketing";
    // } else if (pathName === "/referrals") {
    //   pageTitle = "BiosyncIQ | Referrals";
    // } else if (pathName === "integrations") {
    //   pageTitle = "BiosyncIQ | Integrations";
    else if (pathName === "/settings") {
      pageTitle = "BiosyncIQ | Settings";
    }
    // } else if (pathName === "/profile") {
    //   pageTitle = "BiosyncIQ | Profile";
    // }

    document.title = pageTitle;
  }, [pathName]);

  // useEffect(() => {
  //   dispatch(openTimeModal());
  // }, [pathName]);
  useEffect(() => {
    dispatch(getAllAgenciesListFunc());
    dispatch(getOrganizationFunc());
  }, [workspace]);

  useEffect(() => {
    if (allAgencies?.ok) {
      setAllPractices(allAgencies?.agent?.agencies);
    }
  }, [allAgencies]);

  const currentPractiseAgency = allPractices?.find(
    (item) => item?.id === Number(currentAgencyId)
  );

  // console.log("AAA", agentUser);

  const openStopTimeModalHandler = () => {
    dispatch(setIsStopped(false));
    dispatch(setGoBackFunc(false));
    dispatch(setEndTime(dayjs()));
    dispatch(openTimeModal());

    // if (!isPaused) {
    //   dispatch(setIsRunning(false));
    //   dispatch(setPauseStartTime(Date.now()));
    //   dispatch(setPausedTime(0));
    // }
    // setSelectValue("chat_communication");
  };

  const listItemHandler = (to) => {
    if (selectedPath === to) {
      return;
    }

    if (to === "/patients") {
      dispatch(resetAllPatients());
    }

    if (!isRunning && !isPaused) {
      setSelectedPath(to);
      navigate(`${to}`);
      // dispatch(setEndTime(dayjs()));
      // dispatch(setPauseStartTime(Date.now()));
      // dispatch(setPausedTime(0));
      // dispatch(openTimeModal());
      // dispatch(setNavigateItemFunc(to));
    } else {
      openStopTimeModalHandler();
      dispatch(setNavigateItemFunc(to));
    }
    // dispatch(resetUserFeedNotifications());
    // dispatch(resetClientPainlogs());
    // dispatch(resetAllBodyParts());
    // dispatch(resetPatientDetailByPatientId());
    // dispatch(openTimeModal());
  };

  const openPractiseModalHandler = () => {
    setOpenMorePractiseModal(true);
    closeWorkSpaceHandler();
  };

  const openBillingModalHandler = () => {
    setOpenBillingModal(true);
    closeWorkSpaceHandler();
  };

  const emailChangeHandler = (e) => {
    const emailInputValue = e.target.value;
    setEmail(emailInputValue);

    const emailIsValid = validateEmail(emailInputValue);
    if (emailInputValue && !emailIsValid) {
      setEmailError(true);
      return;
    }
    setEmailError(false);
  };

  const changePractiseHandler = (practiseId) => {
    Cookies.set("agency_id_vita", practiseId);
    closeWorkSpaceHandler();
  };

  // ================   ADD PRACTICE HANDLER ========================
  const addPracticeHandler = () => {
    const agencyObj = {
      agency: {
        name: practiseName,
        primary_email: email,
      },
      organization_id: organizationId,
    };

    dispatch(createWorkspaceFunc(agencyObj));
    setEmailErrorMsg("");
  };

  useEffect(() => {
    if (!loadingAgency && !workspace?.ok) {
      setEmailErrorMsg(workspace?.message);
      setOpenModal(true);
    }
  }, [workspace]);

  useEffect(() => {
    if (!loadingAgent && !invitedAgent?.ok) {
      setPractiseName("");
      setEmail("");
      setOwnerName("");
      setEmailErrorMsg(invitedAgent?.message);
      setOpenModal(true);
    }
  }, [invitedAgent]);

  useEffect(() => {
    if (workspace?.data?.ok) {
      dispatch(resetCreateWorkSpace());
      const agentObj = {
        agency_id: workspace?.data?.agency?.id,
        send_credentials: true,
        agent_obj: {
          first_name: ownerName,
          email: email,
          role: "Owner",
          permissions: {
            access_patient_details: {
              create: true,
              read: true,
              edit: true,
              delete: true,
            },
            // can_chat_client: true,
            can_access_billing: false,
          },
        },
      };
      dispatch(inviteAgentFunc(agentObj));
      setEmailErrorMsg("");
    }
  }, [workspace]);

  useEffect(() => {
    if (invitedAgent?.ok) {
      setOpenInviteMessage(true);
      setSuccessInviteMessage(invitedAgent?.message);
      setPractiseName("");
      setEmail("");
      setOwnerName("");
      setOpenMorePractiseModal(false);
      setEmailError(false);
      setEmailErrorMsg("");
      setOpenMorePractiseModal(false);
      dispatch(resetAgentInvite());
    } else {
      setOpenMorePractiseModal(false);
      dispatch(resetAgentInvite());
    }
  }, [invitedAgent]);

  const openOrganizationPortalHandler = () => {
    window.open("/organization-portal?tab=home", "_blank");
    closeWorkSpaceHandler();
  };

  // ================   ADD PRACTICE HANDLER ========================

  return (
    <>
      {!loadingAgency && emailErrorMsg && (
        <AlertMessage
          message={emailErrorMsg}
          severity="error"
          open={open}
          handleClose={handleClose}
        />
      )}

      {OpenInviteMessage && (
        <AlertMessage
          message={successInviteMessage}
          severity="success"
          open={OpenInviteMessage}
          handleClose={() => setOpenInviteMessage(false)}
        />
      )}

      {/* OPEN STOP TIME MODAL */}
      {openMorePractiseModal && (
        <AlertDialog
          data={{ title: "Add Practice" }}
          openModal={openMorePractiseModal}
          disabled={!practiseName && !email && !ownerName}
          isLoading={loadingAgency || loadingAgent}
          closeModal={() => {
            setPractiseName("");
            setEmail("");
            setOwnerName("");
            setOpenMorePractiseModal(false);
            setEmailError(false);
          }}
          moveFileDialog={true}
          formSubmitFunction={addPracticeHandler}
          submitText="Add Practice"
          maxWidth="538px"
          titlePadding="24px !important"
          closeOverlay={false}
          padding="24px"
          contentPadding="16px 24px"
          height="668px"
        >
          <AddPractiseContent
            email={email}
            emailChangeHandler={emailChangeHandler}
            emailError={emailError}
            practiseName={practiseName}
            setPractiseName={setPractiseName}
            ownerName={ownerName}
            setOwnerName={setOwnerName}
          />
        </AlertDialog>
      )}

      {/* OPEN BILLING MODAL  */}
      {openBillingModal && (
        <AlertDialog
          data={{
            title: "Billing",
            lightText: "Manage your plan and billing here",
          }}
          openModal={openBillingModal}
          borderRadius="8px"
          closeModal={() => {
            setOpenBillingModal(false);
          }}
          moveFileDialog={true}
          cancelIcon={<HighlightOffOutlinedIcon sx={{ color: "#0E0D1E" }} />}
          maxWidth="1258px"
          titlePadding="24px !important"
          closeOverlay={false}
          padding="24px"
          // contentPadding="16px 24px"
          height="846px"
          dialogActions={false}
          showCancelIcon={true}
        >
          <BillingModalContent allPractices={allPractices} />
        </AlertDialog>
      )}

      <Box>
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              // padding: "12px 0",
            },
          }}
          variant="permanent"
          anchor="left"
        >
          {loadingAllAgencies || loadingOrg ? (
            <Box
              padding="8px"
              minHeight="76px"
              boxSizing="border-box"
              display="flex"
              alignItems="center"
              borderBottom="1px solid #EBEBEB"
            >
              <RectangleSkeletons height={60} totalRows={1} />
            </Box>
          ) : (
            <Box
              padding="8px"
              minHeight="76px"
              boxSizing="border-box"
              display="flex"
              alignItems="center"
              borderBottom="1px solid #EBEBEB"
            >
              <PractiseBoxCard
                logoType={currentPractiseAgency?.logo_type}
                iconName={currentPractiseAgency?.icon_name}
                iconColor={currentPractiseAgency?.icon_color}
                logoUrl={currentPractiseAgency?.logo_url}
                mb="0"
                border={true}
                title={currentPractiseAgency?.name}
                open={open}
                switchWorkspaceHandler={switchWorkspaceHandler}
                practiseId={currentPractiseAgency?.id}
                icon={<ExpandMoreRoundedIcon />}
                showEllipsis={true}
                orgPractice={
                  organizationDetail?.organization?.signed_up_as ===
                  "organization"
                }
                // icon={allPractices?.length > 1 && <ExpandMoreRoundedIcon />}
              />
            </Box>
          )}

          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={closeWorkSpaceHandler}
            PaperProps={{
              elevation: 0,
              sx: {
                top: "76px !important",
                overflow: "auto",
                borderRadius: "8px",
                width: "310px",
                boxShadow: "0px 2px 16px 0px rgba(0, 0, 0, 0.08)",
                "& .MuiAvatar-root": {
                  // width: "310px",
                  // height: 32,
                  ml: -0.5,
                  // mr: 1,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <Stack gap="10px" padding="8px 16px 10px 16px">
              <Typography variant="caption" color="secondary">
                {" "}
                Switch Workspace{" "}
              </Typography>
            </Stack>
            <Stack
              paddingBottom="8px"
              height={allPractices?.length > 5 ? "282px" : "auto"}
              overflow="auto"
            >
              {allPractices?.map((item, index) => (
                <MenuItem
                  onClick={() => {
                    changePractiseHandler(item?.id);
                    dispatch(changedAgencyIdFunc(true));
                    dispatch(resetPatientListingStates());
                  }}
                  key={index}
                >
                  <PractiseBoxCard
                    mb={0}
                    title={item?.name}
                    open={open}
                    logoType={item?.logo_type}
                    iconName={item?.icon_name}
                    iconColor={item?.icon_color}
                    logoUrl={item?.logo_url}
                    // switchWorkspaceHandler={switchWorkspaceHandler}
                    practiseId={item?.id}
                    icon={
                      item?.id === Number(currentAgencyId) && <TickCircleIcon />
                    }
                  />
                </MenuItem>
              ))}
            </Stack>
            {/* <Divider /> */}

            {/* <StyledMenuItem onClick={openPractiseModalHandler}>
              <ListItemIcon sx={{ marginRight: "10px" }}>
                <AddPractiseIconBlack />{" "}
              </ListItemIcon>
              Add Practice
            </StyledMenuItem> */}
            {/* {(agentUser?.agent?.role === "Organization Admin" ||
              agentUser?.agent?.role === "Owner" ||
              agentUser?.agent?.permissions?.can_access_billing) && (
              <StyledMenuItem onClick={openBillingModalHandler}>
                <ListItemIcon sx={{ marginRight: "10px" }}>
                  <BillingReceiptIcon />{" "}
                </ListItemIcon>
                Billing{" "}
              </StyledMenuItem>
            )} */}
            {(agentUser?.agent?.role === "Organization Admin" ||
              agentUser?.agent?.permissions?.can_access_billing === true) && (
              <Box padding="16px 28px">
                <Button
                  disableElevation
                  sx={{
                    padding: "8px 16px",
                    background:
                      "linear-gradient(90deg, #0C80F3 0%, #2954F2 100%)",
                    "&:hover": {
                      background:
                        "linear-gradient(180deg, #0C80F3 0%, #5865E1 100%)",
                    },
                  }}
                  startIcon={<OrganizationIcon />}
                  fullWidth
                  variant="contained"
                  onClick={openOrganizationPortalHandler}
                >
                  {" "}
                  Organization Portal
                </Button>
              </Box>

              // <StyledMenuItem onClick={openBillingModalHandler}>
              //   <ListItemIcon sx={{ marginRight: "10px" }}>
              //     <BillingReceiptIcon />{" "}
              //   </ListItemIcon>
              //   Organization Portal
              // </StyledMenuItem>
            )}
          </Menu>
          <Divider />

          <List
            sx={{
              height: "100%",
              paddingTop: "12px",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Stack gap="8px" padding="0 16px">
              {dashboardLists.map((text, index) => (
                <StyledListItem
                  key={index}
                  disablePadding
                  sx={{
                    // left: "0 !important",
                    borderRadius: "8px !important",
                    color: "#212121 !important",
                    "&:hover": {
                      background: "rgba(12, 128, 243, 0.10)",
                      color: "#0C80F3 !important",
                      "& svg path": {
                        stroke: "#0C80F3",
                      },
                    },
                    width: text.className && "216px",
                    position: text.className && "absolute",
                    bottom: text.className && "94px !important",
                  }}
                  className={`${
                    selectedPath === text.to ||
                    text.alternateName?.some((path) =>
                      selectedPath?.startsWith(path)
                    )
                      ? "activeTab"
                      : ""
                  }`}
                >
                  <ListItemButton
                    disableRipple
                    selected={
                      selectedPath === text.to ||
                      text.alternateName?.some((path) =>
                        selectedPath?.startsWith(path)
                      )
                    }
                    onClick={() => {
                      if (text.className === "helpBottom") {
                        helpLinkHandler();
                      } else {
                        if (
                          selectedPath === "/patients" &&
                          text?.to?.startsWith(selectedPath)
                        ) {
                          return;
                        }

                        dispatch(resetPatientListingStates());
                        dispatch(resetAssignBulk());
                        dispatch(resetImportStatus());
                        listItemHandler(text.to);
                      }
                    }}
                    sx={{
                      "&:hover": {
                        backgroundColor: "transparent !important",
                      },
                    }}
                  >
                    <StyledListItemIcon>
                      {React.cloneElement(text.icon, {
                        color:
                          selectedPath === text.to ||
                          text.alternateName?.some((path) =>
                            selectedPath?.startsWith(path)
                          )
                            ? "#fff"
                            : "#212121",
                      })}
                    </StyledListItemIcon>
                    <StyledListItemText
                      primary={text.title}
                      className={`${
                        selectedPath === text.to ||
                        text.alternateName?.some((path) =>
                          selectedPath?.startsWith(path)
                        )
                          ? "activeColor"
                          : ""
                      }`}
                    />
                  </ListItemButton>
                  {/* {
                  <Box
                    position="absolute"
                    top="0"
                    right="0"
                    bgcolor="#566875"
                    borderRadius="0px 0px 8px 8px"
                    padding="0 4px"
                  >
                    <Typography variant="caption" color="#fff">
                      Coming Soon
                    </Typography>
                  </Box>
                } */}
                </StyledListItem>
              ))}
            </Stack>

            <StyledListItem
              className={`${selectedPath === "/profile" ? "activeTab" : ""}`}
              sx={{
                padding: "2px 16px 12px",
                position: "absolute",
                bottom: "0 !important",
                borderTop: "1px solid #EBEBEB",
                "&:hover": {
                  background: "rgba(12, 128, 243, 0.10)",
                },
              }}
            >
              <Box sx={{ width: "100%" }}>
                <UserProfileBox />
                <Typography
                  variant="caption"
                  sx={{
                    color: "#464646",
                    display: "block",
                    mt: "2px",
                    p: "0 6px",
                    fontSize: "1.4rem",
                  }}
                >
                  version: 1.3.0
                </Typography>
              </Box>
            </StyledListItem>
          </List>
        </Drawer>
      </Box>
    </>
  );
};

export default Sidedrawer;
